/**
 * Заголовок раздела: название, пояснение под ним и действия справа.
 * Одинаковый во всех разделах — по нему пользователь понимает,
 * где находится и что здесь можно сделать.
 */
import styles from './PageHeader.module.css';

export default function PageHeader({ title, subtitle, actions, children }) {
  return (
    <header className={styles.header}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
      {children}
    </header>
  );
}
